import api from '../../api/index'
import * as types from '../../types/index'

export default {
  state: {
    pageCurrent: 1,
    myLoanData: {
      recedSum: '0.00',
      balancedSum: '0.00',
      recedPrincipal: '0.00',
      recedInterest: '0.00',
      balancedPrincipal: '0.00',
      balancedInterest: '0.00',
      availableQuota: '0.00',
      totalQuota: '0.00'
    },
    frontItemApplyState: ''
  },
  getters: {
    [types.MY_LOAN_DATA]: state => state.myLoanData,
    [types.FRONT_ITEM_STATE_FRONT]: state => state.frontItemApplyState
  },
  mutations: {
    // 设置我的借款页面数据（不包括列表）
    [types.SET_MY_LOAN_DATA] (state, data) {
      state.myLoanData = data
    },
    [types.SET_FRONT_ITEM_STATE_FRONT] (state, data) {
      state.frontItemApplyState = data
    }
  },
  actions: {
    // 获取我的借款页面数据（不输出列表数据）
    [types.GET_MY_LOAN_DATA] ({commit, dispatch}, params) {
      return api.getMyLoanData({
        token: params.token,
        frontApplyState: params.frontApplyState,
        pageCurrent: params.pageCurrent
      }).then((res) => {
        const resData = res.data

        if (Number(resData.code) === 0) {
          // 后台关闭额度开关后，没有对应字段返回
          if (res.data.data.availableQuota === undefined) {
            res.data.data.availableQuota = ''
          }
          commit(types.SET_MY_LOAN_DATA, res.data.data)
        } else {
          if (Number(resData.code) !== 0) {
            commit(types.SET_MY_LOAN_DATA, {
              recedSum: '0.00',
              balancedSum: '0.00',
              recedPrincipal: '0.00',
              recedInterest: '0.00',
              balancedPrincipal: '0.00',
              balancedInterest: '0.00',
              // availableQuota: resData.data.availableQuota ? resData.data.availableQuota : '0.00',
              // totalQuota: resData.data.totalQuota ? resData.data.totalQuota : '0.00'
              availableQuota: '0.00',
              totalQuota: '0.00',
              recedConsulting: '0.00',
              recedPunish: '0.00',
              balancedConsulting: '0.00',
              balancedPunish: '0.00',
            })
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/myLoan.js